import { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import Header from './Header/Header';
import { CustomHeaderProps } from './Header/Header.types';

export const hideHeader: NativeStackNavigationOptions = { headerShown: false };
export const disableGesture: NativeStackNavigationOptions = {
  gestureEnabled: false,
};
export const disableAnimation: NativeStackNavigationOptions = {
  animation: 'none',
};

export const transparentHeader: NativeStackNavigationOptions = {
  headerTransparent: true,
};

export const defaultScreenOptions: NativeStackNavigationOptions = {
  title: '',
  freezeOnBlur: true,
  fullScreenGestureEnabled: true,
  headerShadowVisible: false,
  headerBackButtonDisplayMode: 'minimal',
  header: (props: CustomHeaderProps) => <Header {...props} />,
};
